import * as yup from 'yup';
import { TREASURY_REDEEM_MAX_DAY } from '../../../constants/treasury';
import { treasuryRedeemRuleFormFields } from '../../fields/formFields/treasuryRedeemRule';
import { amountSchema } from '../common/amountSchema';

export const treasuryRedeemRuleSchema = yup.object({
  [treasuryRedeemRuleFormFields.portfolioId]: yup
    .number()
    .typeError('Pick a treasury portfolio')
    .required('Pick a treasury portfolio'),
  [treasuryRedeemRuleFormFields.amount]: amountSchema,
  [treasuryRedeemRuleFormFields.frequency]: yup.string().required(),
  [treasuryRedeemRuleFormFields.dayOfMonth]: yup.number().min(1).max(TREASURY_REDEEM_MAX_DAY).required(),
  [treasuryRedeemRuleFormFields.monthOfYear]: yup.number().min(1).max(12).required(),
  [treasuryRedeemRuleFormFields.insufficientFundsAction]: yup.string().required(),
});
